import { Component, OnInit, Inject } from '@angular/core';
import { HttpEventType, HttpClient, HttpRequest, HttpParams } from '../../../../node_modules/@angular/common/http';
import { Globals } from '../../globals';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '../../../../node_modules/@angular/forms';
import { CompanyService } from 'src/app/service/company.service';
import { ConfigurationsService } from 'src/app/Service/configurations.service';
import * as XLSX from 'xlsx';

type AOA = any[][];
@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html'
})
export class UploadFileComponent {

  CompanyId: number = 0;
  public progress: number;
  public message: string;
  public errorMsg: string = '';
  public files: any = [];
  res: any;
  FileName: string;
  disablebutton: boolean = false;
  DisplayMsg: boolean = false;
  successMsg: string;
  btnName: string;
  IsFromMain: boolean;
  excelData: AOA = [];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };

  constructor(private http: HttpClient, public dialogref: MatDialogRef<UploadFileComponent>, private configService: ConfigurationsService, @Inject(MAT_DIALOG_DATA) public data: any, private companyservice: CompanyService) {

    if (data && data.CompanyId) {
      this.CompanyId = data.CompanyId;
    }
    if (data.isFromMeterConfig == 'Y') {
      this.btnName = 'Import';
      this.IsFromMain = true;
    }
    if (data && data.MeterId) {
      this.btnName = 'Import';
      this.IsFromMain = false;
    }
    else {
      this.btnName = 'Upload';
    }
    dialogref.disableClose = true;
  }


  onFileChange(evt: any) {
    this.errorMsg = ""
    this.successMsg = ""
    const input = evt.target as HTMLInputElement;
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    this.files = target.files;
    for (let file of this.files) {
      file.strsize = this.getReadableFileSizeString(target.files[0].size);
    }
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const allowedExtensions = ['xls', 'xlsx', 'csv'];
    const files = Array.from(target.files);

    const invalidFiles = files.filter(file => {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      return !fileExtension || !allowedExtensions.includes(fileExtension);
    });

    if (invalidFiles.length > 0) {
      this.errorMsg = 'Only .xls & .xlsx files are allowed.'
      input.value = ''; // Clear the input value
      return;
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.excelData = XLSX.utils.sheet_to_json(ws);
    };
    reader.readAsBinaryString(target.files[0]);

  }

  upload(evt: any): void {
    this.errorMsg = "";
    this.successMsg = "";
    if (this.data && this.data.MeterId >= 0) {
      this.validateFileUpload(evt, ['pdf'], 'Only .pdf files are allowed.');
    }
    else {
      this.validateFileUpload(evt, ['jpg', 'jpeg', 'png'], 'Only .jpg, .jpeg & .png files are allowed.');
    }

  }

  validateFileUpload(evt: any, allowedExtensions: string[], errorMsg: string): void {
    const input = evt.target as HTMLInputElement;
    const target: DataTransfer = <DataTransfer>evt.target;
    this.files = target.files;

    // Attach readable file size string
    Array.from(this.files).forEach((file: any) => {
      file.strsize = this.getReadableFileSizeString(file.size);
    });

    if (this.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    // Validate file extensions
    const invalidFiles = Array.from(this.files).filter((file: any) => {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      return !fileExtension || !allowedExtensions.includes(fileExtension);
    });

    if (invalidFiles.length > 0) {
      this.errorMsg = errorMsg;
      input.value = ''; // Clear the input value
    }
  }

  // Call on click select File
  // upload(files:any) {
  //   const input = files.target as HTMLInputElement;
  //   const allowedExtensions = ['xls', 'xlsx', 'csv'];
  //   const files = Array.from(target.files);

  //   const invalidFiles = files.filter(file => {
  //     const fileExtension = file.name.split('.').pop()?.toLowerCase();
  //     return !fileExtension || !allowedExtensions.includes(fileExtension);
  //   });

  //   if (invalidFiles.length > 0) {
  //     this.errorMsg = 'Only .xls & .xlsx files are allowed.'
  //     input.value = ''; // Clear the input value
  //     return;
  //   }
  //   this.message = '';
  //   if (files.length === 0) {
  //     return;
  //   }
  //   else {
  //     this.files = files;
  //   }
  //   for (let file of files) {
  //     file.strsize = this.getReadableFileSizeString(file.size);
  //   }

  // }

  // To count file size unit wise
  getReadableFileSizeString(fileSizeInBytes) {
    this.errorMsg = ""
    this.successMsg = ""

    var i = -1;
    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  }

  // called on click upload button
  OnClick(): void {
    this.errorMsg = "";

    if (this.IsFromMain) {
      this.dialogref.close(this.excelData);
      return;
    }

    if (this.data && this.data.MeterId >= 0) {
      this.handleFileUpload("CalibrationCertificate", (response: any) => {
        this.dialogref.close(response.FileName);
      });
    } else {
      this.handleFileUpload("CompanyLogo", (response: any) => {
        const reqObj = {
          CompanyId: this.CompanyId,
          IsforupdateLogoOnly: 'Y',
          CompanyLogo: response.FileName
        };

        this.companyservice.AddCompany(reqObj).subscribe(
          () => {
            this.successMsg = 'Upload successfully';
          },
          (error) => {
            this.errorMsg = error;
          }
        );
      });
    }
  }

  handleFileUpload(folderName: string, successCallback: (response: any) => void): void {
    const formData = new FormData();

    for (let file of this.files) {
      formData.append(file.name, file);
    }
    formData.append("FolderName", folderName);

    this.disablebutton = true;
    const uploadReq = new HttpRequest('POST', this.configService.serviceUrl('ServiceURL') + 'Company/SaveImage', formData, {
      reportProgress: true
    });

    this.http.request(uploadReq).subscribe(
      event => {
        this.DisplayMsg = false;

        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round(100 * event.loaded / event.total);
        } else if (event.type === HttpEventType.Response) {
          this.disablebutton = false;
          this.res = event.body;
          if (this.res) {
            successCallback(this.res);
          }
        }
      },
      error => {
        this.disablebutton = false;
        this.DisplayMsg = false;
        this.errorMsg = error.error.ErrorMessage;
      }
    );
  }


  // called close button
  Close() {
    this.errorMsg = ""
    this.dialogref.close();
  }

}
